import {
  ADD_DROPBOX_FEEDBACK,
  CREATE_DROPBOX_SUCCESS,
  CREATE_SINGLE_DROPBOX_FILE_SUCCESS,
  DELETE_BULK_UPLOAD_FILE_DROPBOX,
  DELETE_DROPBOX_FILE_SUCCESS,
  DELETE_DROPBOX_SUCCESS,
  DELETE_SELECTED_DROPBOX_SUCESS,
  EDIT_DROPBOX_SUCCESS,
  GET_DROPBOX_DETAILS_USER,
  GET_DROPBOX_FEEDBACK,
  GET_DROPBOX_FILE_LIST_SUCCESS,
  GET_DROPBOX_LIST_FAILED,
  GET_DROPBOX_LIST_SUCCESS,
  GET_DROPBOX_NOTIFICATION_ERROR,
  GET_DROPBOX_NOTIFICATION_SUCCESS,
  MARK_DROPBOX_NOTIFICATION_ERROR,
  MARK_DROPBOX_NOTIFICATION_SUCCESS,
  RESET_DROPBOX_DETAILS,
  RESET_DROPBOX_FILE_DETAIL,
  SET_BULK_FILE_LIST_DROPBOX,
  SET_BULK_UPLOAD_FILE_PROGRESS_DROPBOX,
  UPDATE_DROPBOX_FILE_SUCCESS,
  UPDATE_DROPBOX_SETTING_SUCCESS,
  UPLOAD_MULTIPLE_FILES_SUCCESS,
} from "../constants";
import { cloneDeep, remove } from "lodash";

export const initialState = {
  dropboxDetails: undefined,
  dropboxFileDetails: undefined,
  bulkFileList: [],
  dropboxFeedback: undefined,
  dropboxNotification: undefined,
  dropboxNotificationRead: undefined,
  dropboxCheck: false,
};
export const DropboxReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_DROPBOX_LIST_SUCCESS:
      return {
        ...state,
        dropboxDetails: action.payload,
      };
    case GET_DROPBOX_LIST_FAILED:
      return {
        ...state,
        dropboxDetails: undefined,
      };
    case GET_DROPBOX_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        dropboxNotification: action.payload,
      };
    }
    case GET_DROPBOX_NOTIFICATION_ERROR: {
      return {
        ...state,
        dropboxNotification: undefined,
      };
    }
    case MARK_DROPBOX_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        dropboxNotificationRead: action.payload,
      };
    }
    case MARK_DROPBOX_NOTIFICATION_ERROR: {
      return {
        ...state,
        dropboxNotificationRead: undefined,
      };
    }
    case RESET_DROPBOX_DETAILS: {
      return {
        ...state,
        dropboxDetails: "",
      };
    }

    case CREATE_DROPBOX_SUCCESS: {
      const tempoResDetail = cloneDeep(state.dropboxDetails);
      // tempoResDetail.push(action.payload);
      tempoResDetail.data.splice(0, 0, action.payload);

      return {
        ...state,
        dropboxDetails: tempoResDetail,
      };
    }

    case DELETE_DROPBOX_SUCCESS: {
      let tempoResDetail = cloneDeep(state.dropboxDetails);
      // tempoResDetail = tempoResDetail.filter(
      //   (item) => !action.payload.ids.includes(item._id)
      // );
      remove(tempoResDetail.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        dropboxDetails: tempoResDetail,
      };
    }

    case DELETE_SELECTED_DROPBOX_SUCESS: {
      let tempoResDetail = cloneDeep(state.dropboxDetails);
      // tempoResDetail = tempoResDetail.filter(
      //   (item) => !action.payload.ids.includes(item._id)
      // );
      remove(tempoResDetail.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        dropboxDetails: tempoResDetail,
      };
    }
    case EDIT_DROPBOX_SUCCESS: {
      let tempoResDetail = cloneDeep(state.dropboxDetails);
      const index = tempoResDetail.data.findIndex(
        (obj) => obj._id === action.payload._id
      );
      if (index !== -1) {
        tempoResDetail.data[index] = action.payload;
      }
      return {
        ...state,
        dropboxDetails: tempoResDetail,
      };
    }

    case UPDATE_DROPBOX_SETTING_SUCCESS: {
      let tempoResDetail = cloneDeep(state.dropboxDetails);
      const index = tempoResDetail.data.findIndex(
        (obj) => obj._id === action.payload._id
      );
      if (index !== -1) {
        tempoResDetail.data[index] = action.payload;
      }
      return {
        ...state,
        dropboxDetails: tempoResDetail,
      };
    }
    case GET_DROPBOX_FILE_LIST_SUCCESS: {
      return {
        ...state,
        dropboxFileDetails: action.payload,
      };
    }
    case CREATE_SINGLE_DROPBOX_FILE_SUCCESS: {
      const tempCourseDetails = cloneDeep(state.dropboxFileDetails);
      tempCourseDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        dropboxFileDetails: tempCourseDetails,
      };
    }
    // case CREATE_SINGLE_DROPBOX_FILE_SUCCESS: {
    //   const tempoResFileDetail = cloneDeep(state.dropboxFileDetails);

    //   tempoResFileDetail.data.push(action.payload);
    //   return {
    //     ...state,
    //     dropboxFileDetails: tempoResFileDetail,
    //   };
    // }

    case UPLOAD_MULTIPLE_FILES_SUCCESS: {
      const tempoResFileDetail = cloneDeep(state.dropboxFileDetails);

      tempoResFileDetail.data.push(action.payload);
      return {
        ...state,
        dropboxFileDetails: tempoResFileDetail,
      };
    }
    case DELETE_DROPBOX_FILE_SUCCESS: {
      const tempdropboxFileDetails = cloneDeep(state.dropboxFileDetails);
      remove(tempdropboxFileDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        dropboxFileDetails: action.payload,
      };
    }
    case SET_BULK_FILE_LIST_DROPBOX: {
      return {
        ...state,
        bulkFileList: action.payload,
      };
    }
    case DELETE_BULK_UPLOAD_FILE_DROPBOX: {
      let tempBulkFileListDetails = cloneDeep(state.bulkFileList);
      remove(tempBulkFileListDetails, (obj) => obj.id === action.payload);
      return {
        ...state,
        bulkFileList: tempBulkFileListDetails,
      };
    }
    case SET_BULK_UPLOAD_FILE_PROGRESS_DROPBOX: {
      let tempBulkFileListDetails = cloneDeep(state.bulkFileList);
      tempBulkFileListDetails[action.payload.index].progress =
        action.payload.progress;
      tempBulkFileListDetails[action.payload.index].uploading = true;
      return {
        ...state,
        bulkFileList: tempBulkFileListDetails,
      };
    }
    case RESET_DROPBOX_FILE_DETAIL: {
      return {
        ...state,
        dropboxFileDetails: undefined,
      };
    }
    case UPDATE_DROPBOX_FILE_SUCCESS: {
      const tempdropboxFileDetails = cloneDeep(state.dropboxFileDetails);
      const index = tempdropboxFileDetails.data.findIndex(
        (obj) => obj._id === action.payload._id
      );
      if (index !== -1) {
        if (
          tempdropboxFileDetails.data[index].parent_folder_id ===
          action.payload.parent_folder_id
        ) {
          tempdropboxFileDetails.data[index] = action.payload;
        } else {
          remove(
            tempdropboxFileDetails.data,
            (obj) => obj._id === action.payload._id
          );
        }
      }

      return {
        ...state,
        dropboxFileDetails: tempdropboxFileDetails,
      };
    }

    // case SEARCH_RESOURCE_FILE_DETAILS_SUCCESS: {
    //   //   return {
    //   //     ...state,
    //   //     searchedFileDetails: action.payload,
    //   //   };
    // }

    case ADD_DROPBOX_FEEDBACK: {
      const tempoResDetail = cloneDeep(state.dropboxFeedback);
      tempoResDetail.data.splice(0, 0, action.payload);
      return {
        ...state,
        dropboxFeedback: tempoResDetail,
      };
    }
    case GET_DROPBOX_FEEDBACK: {
      return {
        ...state,
        dropboxFeedback: action.payload,
      };
    }
    case GET_DROPBOX_DETAILS_USER: {
      return {
        ...state,
        dropboxFileDetails: action.payload,
      };
    }
    default:
      return state;
  }
};
